var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, InputTextarea, Typography } from "@uigovpe/components";
import { useCallback, useEffect, useMemo, useState, } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createComment, createSupport, deleteComment, deleteSupport, listComments, updateComment, } from "../../../apis/comments";
import { getConsultationById, } from "../../../apis/consultations";
import { getMyContributions, } from "../../../apis/contributions";
import { getApiErrorMessage } from "../../../apis/http";
import { useAuth } from "../../auth/AuthContext";
import { CommentsThread } from "../components/CommentsThread";
import { buildUserSupportsMap, sortConsultationItems, } from "../utils/participation";
var pageShellStyle = {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    padding: "32px 16px 48px",
};
var pageContainerStyle = {
    display: "grid",
    gap: 24,
    width: "100%",
    maxWidth: 960,
};
var titleCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    borderTop: "8px solid #0B4F8C",
    display: "grid",
    gap: 8,
    padding: 16,
};
var contentCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
    display: "grid",
    gap: 24,
    padding: 24,
};
var sectionHeaderStyle = {
    borderBottom: "1px solid #E5E7EB",
    display: "grid",
    gap: 8,
    paddingBottom: 16,
};
var feedbackStyles = {
    error: { background: "#FFE4E4", color: "#7A1F1F" },
    info: { background: "#E6F3FF", color: "#0B4F8C" },
    success: { background: "#EAFBD7", color: "#245C15" },
    warning: { background: "#FFF7D6", color: "#7A5800" },
};
var feedbackBoxStyle = {
    borderRadius: 12,
    padding: "12px 16px",
};
var actionsRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 16,
    justifyContent: "space-between",
};
var FeedbackBox = function (_a) {
    var message = _a.message, severity = _a.severity;
    return (_jsx("div", __assign({ style: __assign(__assign({}, feedbackBoxStyle), feedbackStyles[severity]) }, { children: _jsx(Typography, { children: message }) })));
};
export var OpenContributionPage = function () {
    var _a;
    var id = useParams().id;
    var consultationId = Number(id);
    var hasValidConsultationId = Number.isFinite(consultationId) && consultationId > 0;
    var navigate = useNavigate();
    var _b = useAuth(), accessToken = _b.accessToken, isAuthenticated = _b.isAuthenticated, isLoadingAuth = _b.isLoadingAuth, hasToken = _b.hasToken, profileError = _b.profileError, role = _b.role, user = _b.user;
    var isCitizen = role === "citizen";
    var _c = useState(""), commentValue = _c[0], setCommentValue = _c[1];
    var _d = useState([]), comments = _d[0], setComments = _d[1];
    var _e = useState(null), commentsError = _e[0], setCommentsError = _e[1];
    var _f = useState(false), commentsLoading = _f[0], setCommentsLoading = _f[1];
    var _g = useState(null), consultation = _g[0], setConsultation = _g[1];
    var _h = useState(null), feedback = _h[0], setFeedback = _h[1];
    var _j = useState(true), loading = _j[0], setLoading = _j[1];
    var _k = useState([]), myContributions = _k[0], setMyContributions = _k[1];
    var _l = useState(null), pageError = _l[0], setPageError = _l[1];
    var _m = useState(false), submitting = _m[0], setSubmitting = _m[1];
    var loadComments = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasValidConsultationId) {
                        return [2 /*return*/];
                    }
                    setCommentsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, listComments(consultationId, {
                            direction: "DESC",
                            limit: 100,
                            page: 0,
                        }, accessToken)];
                case 2:
                    response = _a.sent();
                    setComments(response.data.comments || []);
                    setCommentsError(null);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setCommentsError(getApiErrorMessage(error_1));
                    return [3 /*break*/, 5];
                case 4:
                    setCommentsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [accessToken, consultationId, hasValidConsultationId]);
    var loadMyContributions = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accessToken || !hasValidConsultationId) {
                        setMyContributions([]);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getMyContributions(accessToken)];
                case 2:
                    response = _a.sent();
                    setMyContributions((response.data.contributions || []).filter(function (entry) { return entry.contribution.consultationId === consultationId; }));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    setMyContributions([]);
                    setFeedback({
                        message: getApiErrorMessage(error_2),
                        severity: "warning",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [accessToken, consultationId, hasValidConsultationId]);
    useEffect(function () {
        if (!hasValidConsultationId) {
            setPageError("Consulta inválida.");
            setLoading(false);
            return;
        }
        var isMounted = true;
        var loadPage = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setPageError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getConsultationById(consultationId, accessToken)];
                    case 2:
                        response = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setConsultation(response.data.consultation);
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setPageError(getApiErrorMessage(error_3));
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void loadPage();
        void loadComments();
        return function () {
            isMounted = false;
        };
    }, [accessToken, consultationId, hasValidConsultationId, loadComments]);
    useEffect(function () {
        void loadMyContributions();
    }, [loadMyContributions]);
    var items = useMemo(function () { return sortConsultationItems(consultation === null || consultation === void 0 ? void 0 : consultation.consultationItems); }, [consultation === null || consultation === void 0 ? void 0 : consultation.consultationItems]);
    var discussionPrompt = (_a = items[0]) === null || _a === void 0 ? void 0 : _a.description;
    var userSupports = useMemo(function () { return buildUserSupportsMap(myContributions, consultationId, comments); }, [comments, consultationId, myContributions]);
    var canSubmitContribution = isAuthenticated &&
        isCitizen &&
        (consultation === null || consultation === void 0 ? void 0 : consultation.status) === "active" &&
        (consultation === null || consultation === void 0 ? void 0 : consultation.type) === "without_form";
    var handleActionError = useCallback(function (error) {
        setFeedback({
            message: getApiErrorMessage(error),
            severity: "error",
        });
    }, []);
    var handleSendRootComment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken || !commentValue.trim()) {
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, createComment(consultation.id, {
                            content: commentValue.trim(),
                        }, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all([loadComments(), loadMyContributions()])];
                case 3:
                    _a.sent();
                    setCommentValue("");
                    setFeedback({
                        message: "Comentário enviado com sucesso.",
                        severity: "success",
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_4 = _a.sent();
                    handleActionError(error_4);
                    return [3 /*break*/, 6];
                case 5:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmitReply = function (parentCommentId, content) { return __awaiter(void 0, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, createComment(consultation.id, {
                            content: content,
                            parentCommentId: parentCommentId,
                        }, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Resposta enviada com sucesso.",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_5 = _a.sent();
                    handleActionError(error_5);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateComment = function (commentId, content) { return __awaiter(void 0, void 0, void 0, function () {
        var error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, updateComment(consultation.id, commentId, { content: content }, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Comentário atualizado.",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_6 = _a.sent();
                    handleActionError(error_6);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteComment = function (commentId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, deleteComment(consultation.id, commentId, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all([loadComments(), loadMyContributions()])];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Comentário excluído.",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_7 = _a.sent();
                    handleActionError(error_7);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAddSupport = function (commentId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, createSupport(consultation.id, commentId, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all([loadComments(), loadMyContributions()])];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Apoio registrado.",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_8 = _a.sent();
                    handleActionError(error_8);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveSupport = function (commentId, supportId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, deleteSupport(consultation.id, commentId, supportId, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all([loadComments(), loadMyContributions()])];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Apoio removido.",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_9 = _a.sent();
                    handleActionError(error_9);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ style: pageShellStyle }, { children: _jsxs("div", __assign({ style: pageContainerStyle }, { children: [_jsx("div", { children: _jsx(Button, { label: "Voltar para a consulta", onClick: function () {
                            return navigate(consultation
                                ? "/details/".concat(consultation.id)
                                : "/details/".concat(consultationId));
                        }, severity: "secondary" }) }), feedback ? _jsx(FeedbackBox, __assign({}, feedback)) : null, loading ? (_jsx(Typography, { children: "Carregando contribui\u00E7\u00E3o..." })) : pageError || !consultation ? (_jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(FeedbackBox, { message: pageError || "Consulta não encontrada.", severity: "error" }), _jsx("div", { children: _jsx(Button, { label: "Voltar para consultas", onClick: function () { return navigate("/"); } }) })] }))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: titleCardStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "lg" }, { children: consultation.title })), consultation.description ? (_jsx(Typography, { children: consultation.description })) : null] })), _jsxs("div", __assign({ style: contentCardStyle }, { children: [!isLoadingAuth && !hasToken ? (_jsx(FeedbackBox, { message: "Fa\u00E7a login pelo Smartpass para registrar sua contribui\u00E7\u00E3o, responder coment\u00E1rios e apoiar manifesta\u00E7\u00F5es.", severity: "info" })) : null, !isLoadingAuth && hasToken && profileError ? (_jsx(FeedbackBox, { message: "N\u00E3o foi poss\u00EDvel carregar seu perfil. Tente recarregar a p\u00E1gina.", severity: "error" })) : null, isAuthenticated && !isCitizen ? (_jsx(FeedbackBox, { message: "Apenas perfis citizen podem enviar contribui\u00E7\u00F5es nesta tela.", severity: "info" })) : null, consultation.status !== "active" ? (_jsx(FeedbackBox, { message: "Esta consulta n\u00E3o est\u00E1 mais recebendo novas contribui\u00E7\u00F5es.", severity: "warning" })) : null, consultation.type === "with_form" ? (_jsx(FeedbackBox, { message: "Esta consulta utiliza formul\u00E1rio estruturado. Use o fluxo correto em /form/".concat(consultation.id, "."), severity: "warning" })) : null, _jsxs("div", __assign({ style: sectionHeaderStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "md" }, { children: "Envie sua contribui\u00E7\u00E3o" })), _jsx(Typography, { children: discussionPrompt || "Digite sua resposta aqui..." })] })), _jsx(InputTextarea, { disabled: !canSubmitContribution, onChange: function (event) {
                                        return setCommentValue(event.target.value);
                                    }, placeholder: "Digite sua resposta aqui...", rows: 4, value: commentValue }), _jsxs("div", __assign({ style: actionsRowStyle }, { children: [_jsx(Button, { label: "Limpar formul\u00E1rio", link: true, onClick: function () { return setCommentValue(""); }, severity: "secondary" }), _jsx(Button, { disabled: submitting || !commentValue.trim() || !canSubmitContribution, label: submitting ? "Enviando..." : "Enviar", onClick: handleSendRootComment })] }))] })), _jsxs("div", __assign({ style: contentCardStyle }, { children: [_jsx("div", __assign({ style: sectionHeaderStyle }, { children: _jsx(Typography, __assign({ fontWeight: "bold", size: "md" }, { children: "Coment\u00E1rios e respostas" })) })), commentsError ? (_jsx(FeedbackBox, { message: commentsError, severity: "error" })) : commentsLoading ? (_jsx(Typography, { children: "Carregando coment\u00E1rios..." })) : (_jsx(CommentsThread, { comments: comments, currentUserId: user === null || user === void 0 ? void 0 : user.id, currentUserRole: role, emptyMessage: "Nenhuma contribui\u00E7\u00E3o aberta registrada ainda.", onAddSupport: accessToken ? handleAddSupport : undefined, onDeleteComment: accessToken ? handleDeleteComment : undefined, onRemoveSupport: accessToken ? handleRemoveSupport : undefined, onSubmitReply: accessToken ? handleSubmitReply : undefined, onUpdateComment: accessToken ? handleUpdateComment : undefined, userSupports: userSupports }))] }))] }))] })) })));
};
